import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VContainer,
        [
          _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          dense: "",
                          filled: "",
                          "hide-details": "auto",
                          label: "Caso de uso",
                          outlined: "",
                          placeholder: "Caso de uso",
                          readonly: "",
                        },
                        model: {
                          value: _vm.item.business_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "business_name", $$v)
                          },
                          expression: "item.business_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6" } },
                    [
                      _c(VTextField, {
                        staticClass: "ml-2",
                        attrs: {
                          dense: "",
                          filled: "",
                          "hide-details": "auto",
                          label: "Respuesta",
                          outlined: "",
                          placeholder: "Respuesta",
                          readonly: "",
                        },
                        model: {
                          value: _vm.item.response,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "response", $$v)
                          },
                          expression: "item.response",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VTabs,
                {
                  staticClass: "mt-2",
                  attrs: { "center-active": "", "fixed-tabs": "" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(VTab, [
                    _vm._v(" " + _vm._s(_vm.$t("frases.search")) + " "),
                  ]),
                  _c(VTab, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("frases.attributes_group")) + " "
                    ),
                  ]),
                  _c(VTab, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("frases.attributes_selection")) + " "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                staticClass: "mt-2 hidden-xs-only",
                                attrs: {
                                  placeholder: "Buscar",
                                  "prepend-inner-icon": "mdi-magnify",
                                  "hide-details": "",
                                  filled: "",
                                  rounded: "",
                                  dense: "",
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.sendToSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.q,
                                  callback: function ($$v) {
                                    _vm.q = $$v
                                  },
                                  expression: "q",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.encontrado.busqueda.length > 0
                            ? _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VDataTable, {
                                    staticClass: "text-center table-inca",
                                    attrs: {
                                      responsive: "",
                                      items: _vm.encontrado.busqueda,
                                      headers: _vm.headers,
                                      "hide-default-footer": "",
                                      "items-per-page":
                                        _vm.pagination.search.limit,
                                      page: _vm.pagination.search.current,
                                      loading: _vm.isLoading,
                                      disabled: _vm.isLoading,
                                    },
                                    on: {
                                      pagination: function ($event) {
                                        _vm.pagination.search.total =
                                          $event.itemsLength
                                      },
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.pagination.search,
                                          "current",
                                          $event
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header.actions",
                                          fn: function (ref) {
                                            var header = ref.header
                                            return [
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: { medium: "" },
                                                  on: { click: _vm.addAllItem },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-plus-circle-outline "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.no_nulo",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.no_nulo === -1
                                                      ? "-"
                                                      : Math.round(
                                                          item.no_nulo
                                                        ) + "%"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.actions",
                                          fn: function (ref) {
                                            var item = ref.item
                                            return [
                                              _c(VHover, {
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var hover = ref.hover
                                                        return [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                medium: "",
                                                                color:
                                                                  item.status &&
                                                                  hover
                                                                    ? "#F03063"
                                                                    : item.status &&
                                                                      !hover
                                                                    ? "#0021CF"
                                                                    : !item.status &&
                                                                      !hover
                                                                    ? "#4B4D53"
                                                                    : "#0021CF",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.editItem(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.status &&
                                                                      hover
                                                                      ? "mdi-minus-circle-outline"
                                                                      : item.status &&
                                                                        !hover
                                                                      ? "mdi-check-circle-outline"
                                                                      : !item.status &&
                                                                        !hover
                                                                      ? "mdi-plus-circle-outline"
                                                                      : "mdi-check-circle-outline"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1394098300
                                    ),
                                  }),
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-left pb-2" },
                                      [
                                        _c(VPagination, {
                                          attrs: {
                                            length: Math.ceil(
                                              _vm.encontrado.found /
                                                _vm.encontrado.per_page
                                            ),
                                            circle: "",
                                            "total-visible": 7,
                                          },
                                          on: { input: _vm.next },
                                          model: {
                                            value: _vm.encontrado.page,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.encontrado,
                                                "page",
                                                $$v
                                              )
                                            },
                                            expression: "encontrado.page",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            {
                              staticClass: "mt-3 pl-4 pr-4",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          items: _vm.attribute_groups,
                                          placeholder: _vm.$t(
                                            "frases.attributes_group"
                                          ),
                                          label: _vm.$t(
                                            "frases.attributes_group"
                                          ),
                                          "item-text": _vm.formatItemText,
                                          small: "",
                                          dense: "",
                                          outlined: "",
                                          "return-object": "",
                                          "hide-details": "auto",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.key_detail_group += 1
                                          },
                                        },
                                        model: {
                                          value: _vm.group_selected,
                                          callback: function ($$v) {
                                            _vm.group_selected = $$v
                                          },
                                          expression: "group_selected",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.group_selected
                            ? _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c("view-attribute-group-component", {
                                    key: _vm.key_detail_group,
                                    attrs: {
                                      item: _vm.group_selected,
                                      enable_actions: true,
                                      enable_edit_sandbox: true,
                                      edit_attributes: _vm.attributes_edit,
                                    },
                                    on: {
                                      onSelectAttr: _vm.onSelectAttr,
                                      addAllGroup: _vm.addAllGroup,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            [
                              _c(VDataTable, {
                                key: _vm.keyTable,
                                staticClass: "table-inca elevation-2",
                                attrs: {
                                  items: _vm.attributesList,
                                  headers: _vm.headers,
                                  dense: "",
                                  "hide-default-footer": true,
                                  "group-by": "categoria",
                                  "items-per-page": _vm.pagination.limit,
                                  page: _vm.pagination.current,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination,
                                      "current",
                                      $event
                                    )
                                  },
                                  pagination: function ($event) {
                                    _vm.pagination.total = $event.itemsLength
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.no_nulo",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.no_nulo === -1
                                                ? "-"
                                                : Math.round(item.no_nulo) + "%"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.actions",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(VHover, {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var hover = ref.hover
                                                  return [
                                                    _c(
                                                      VIcon,
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          medium: "",
                                                          color: hover
                                                            ? "#F03063"
                                                            : "#0021CF",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeItem(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              hover
                                                                ? "mdi-minus-circle-outline"
                                                                : "mdi-check-circle-outline"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "group.header",
                                    fn: function (ref) {
                                      var items = ref.items
                                      var isOpen = ref.isOpen
                                      var toggle = ref.toggle
                                      var group = ref.group
                                      return [
                                        _c(
                                          "th",
                                          {
                                            attrs: {
                                              colspan: _vm.headers.length,
                                            },
                                          },
                                          [
                                            _c(
                                              VCard,
                                              {
                                                attrs: {
                                                  flat: "",
                                                  color: "transparent",
                                                },
                                              },
                                              [
                                                _c(
                                                  VCardActions,
                                                  { staticClass: "mt-2" },
                                                  [
                                                    _c(
                                                      VRow,
                                                      { attrs: { dense: "" } },
                                                      [
                                                        _c(VCol, [
                                                          _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      toggle,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      isOpen
                                                                        ? "mdi-minus"
                                                                        : "icon-add"
                                                                    ) + " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    items[0]
                                                                      .categoria
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c(
                                                                VChip,
                                                                {
                                                                  staticClass:
                                                                    "ml-2",
                                                                  attrs: {
                                                                    label: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      items.length
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]),
                                                        _c(
                                                          VCol,
                                                          {
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _vm
                                                              .partitionsByTable[
                                                              items[0].tabla
                                                            ] &&
                                                            _vm
                                                              .partitionsByTable[
                                                              items[0].tabla
                                                            ].values
                                                              ? _c(
                                                                  VRow,
                                                                  {
                                                                    attrs: {
                                                                      dense: "",
                                                                      align:
                                                                        "center",
                                                                      justify:
                                                                        "end",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      VSelect,
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Periodo",
                                                                          type: "text",
                                                                          items:
                                                                            _vm
                                                                              .partitionsByTable[
                                                                              items[0]
                                                                                .tabla
                                                                            ]
                                                                              .values,
                                                                          "item-value":
                                                                            "id",
                                                                          "item-text":
                                                                            "name",
                                                                          rules:
                                                                            _vm
                                                                              .rules
                                                                              .period,
                                                                          multiple:
                                                                            "",
                                                                          "persistent-hint":
                                                                            "",
                                                                          "prepend-icon":
                                                                            "mdi-calendar",
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          "single-line":
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.onChangePartitions(
                                                                                items[0]
                                                                                  .tabla
                                                                              )
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .partitionsByTable[
                                                                              items[0]
                                                                                .tabla
                                                                            ]
                                                                              .selection,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .partitionsByTable[
                                                                                  items[0]
                                                                                    .tabla
                                                                                ],
                                                                                "selection",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "partitionsByTable[items[0].tabla].selection",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("pagination-vue", {
                                attrs: { pagination: _vm.pagination },
                              }),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right mt-2 mr-2",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        color: "primary",
                                        type: "button",
                                      },
                                      on: { click: _vm.onUpdate },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.item.status_id === 7
                                              ? "Solicitar"
                                              : _vm.$t("botones.boton_update")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }